import AccountController from "@/controllers/AccountController.js";
import store from "@/stores/store.js";
import { RESET_TOKEN, SET_ACCESS_TOKEN } from "@/stores/account/AccountActionTypes";
import TokenService from "@/services/common/auth/TokenService";
import ErrorService from "@/services/common/ErrorService.js";

/**
 * @summary Faz o login do usuário no sistema.
 * @param {object} login
 */
const Login = async function(login)
{
	const resp = await AccountController.Login(login);

	store.dispatch(`AccountModule/${SET_ACCESS_TOKEN}`, resp.data.token);

	TokenService.CreateSessionCookie(resp.data, login.isPermanent);
};

/**
 * @summary Busca o token de acesso no back-end para usuários logados.
 * @returns {string} Token de acesso do back-end
 */
const GetRefresheToken = async function()
{
	const resp = await AccountController.GetAcessToken();

	TokenService.RefreshSessionCookie(resp.data);

	store.dispatch(`AccountModule/${SET_ACCESS_TOKEN}`, resp.data.token);

	return resp.data;
};

/**
 * @summary Faz chamada de logout e apaga tudo no localStore.
 */
const Logout = async function()
{
	try
	{
		await AccountController.Logout();
	}
	catch (error)
	{
		const e = ErrorService.HandleError(error);
	}
	finally
	{
		store.dispatch(`AccountModule/${RESET_TOKEN}`);
		localStorage.removeItem("token");
		localStorage.removeItem("expired-date");
		localStorage.removeItem("user");
		localStorage.removeItem("company");
		localStorage.removeItem("companies");
		localStorage.removeItem("company");
		localStorage.removeItem("permanent-login");
		TokenService.DeleteSessionCookieJWTExpiredAt();
		TokenService.DeleteSessionExpiredAtCookie();
		TokenService.DeleteSessionCookie();
	}
};

export default {
	GetRefresheToken,
	Login,
	Logout,
};
